export default "__VITE_ASSET__J1c$YA$e1yBShps3nZNNpg__"